export const orderedSteps = ['CHOOSE_DESTINATION', 'VALIDATION', 'CONFIRM_SELECTION', 'AWAITING_ACTION', 'ERROR', 'SUCCESS'];